import React from 'react';
interface VideoSpeedIconProps extends React.SVGProps<SVGSVGElement> {
	fill?: string;
	width?: number;
	height?: number;
}

export function VideoSpeedIcon({
	width = 16,
	height = 16,
	fill = 'currentColor',
	...props
}: Readonly<VideoSpeedIconProps>) {
	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_857_42086)" fill={fill}>
				<path d="M8.969 16.464V7.475c0-.4.393-.641.69-.423l6.107 4.495c.27.199.27.646 0 .846l-6.107 4.494c-.297.219-.69-.022-.69-.423zM5.94 18.89c.276-.277.716-.293 1.035-.067a8.45 8.45 0 003.474 1.44c.386.065.685.387.685.779 0 .438-.373.787-.807.72a9.94 9.94 0 01-4.325-1.793c-.355-.258-.373-.769-.062-1.08z" />
				<path d="M12.634 2.728c0-.438.374-.787.808-.72 4.783.748 8.442 4.884 8.442 9.877s-3.659 9.129-8.442 9.876c-.434.068-.808-.28-.808-.72 0-.39.3-.713.686-.779a8.5 8.5 0 000-16.754c-.385-.066-.686-.389-.686-.78zM2.728 12.635c.391 0 .714.3.78.686a8.45 8.45 0 001.438 3.473c.226.319.21.758-.067 1.035-.31.31-.821.293-1.08-.062a9.94 9.94 0 01-1.79-4.325c-.068-.433.28-.807.72-.807zM4.88 5.94c.276.277.292.717.066 1.036a8.45 8.45 0 00-1.438 3.474c-.066.386-.389.685-.78.685-.438 0-.787-.373-.72-.807.25-1.599.878-3.072 1.791-4.325.259-.355.77-.373 1.08-.062zM11.134 2.728c0 .391-.3.714-.685.78a8.451 8.451 0 00-3.474 1.439c-.319.226-.759.21-1.035-.067-.31-.31-.293-.821.062-1.08a9.942 9.942 0 014.325-1.792c.434-.067.807.282.807.72z" />
			</g>
			<defs>
				<clipPath id="clip0_857_42086">
					<path fill={fill} d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
